// Island Ride business constants
export const BUSINESS = {
  name: 'Island Ride',
  tagline: 'Staten Island Cab Service',
  phone: '718.400.8989',
  phoneTel: 'tel:7184008989',
  whatsappNumber: '17184008989',
  whatsappUrl: 'https://wa.me/17184008989',
  email: 'bookings@goislandride.com',
  emailMailto: 'mailto:bookings@goislandride.com',
  domain: 'goislandride.com',
  serviceAreaCore: [
    'Ferry / St. George',
    'New Dorp',
    'Grant City',
    'Dongan Hills',
    'Oakwood',
    'Richmondtown',
  ],
  hours: '24/7',
  fleet: 'Sedans · Minivans · SUVs',
};

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1770461846593-7d31ce0e2719?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1400',
  serviceAreaMap: 'https://customer-assets.emergentagent.com/job_ferry-ride-hub/artifacts/botj9jry_ChatGPT%20Image%20May%2016%2C%202026%2C%2006_53_17%20PM.png',
  serviceArea: 'https://images.unsplash.com/photo-1618243539083-50d8840e122f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  local: 'https://images.unsplash.com/photo-1560580393-bd7d9b095b44?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  airport: 'https://images.unsplash.com/photo-1761588839170-152dc8cf3746?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  outOfTown: 'https://images.unsplash.com/photo-1562009892-1f3b61862083?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
  interior: 'https://images.unsplash.com/photo-1652860316277-370ca5b1b1df?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200',
};

// Hero carousel — Staten Island landmarks & points of interest
// Alt text optimized for local SEO: naturally incorporates target keywords
// (Staten Island cab/taxi/car service, ferry, airport routes, neighborhoods)
export const HERO_SLIDES = [
  {
    src: 'https://images.unsplash.com/photo-1760974015791-cf0dd376aa18?fm=jpg&q=85&w=1400&auto=format&fit=crop',
    alt: 'Staten Island Ferry passing the Statue of Liberty — Island Ride provides cab service from the St. George Ferry Terminal to neighborhoods across Staten Island',
    caption: 'Staten Island Ferry · Statue of Liberty',
  },
  {
    src: 'https://images.unsplash.com/photo-1722206335508-f370f8ba10d4?fm=jpg&q=85&w=1400&auto=format&fit=crop',
    alt: 'Verrazzano-Narrows Bridge connecting Staten Island to Brooklyn — Island Ride offers out-of-town car service to Brooklyn, Manhattan, and beyond',
    caption: 'Verrazzano-Narrows Bridge',
  },
  {
    src: 'https://images.unsplash.com/photo-1770461846593-7d31ce0e2719?fm=jpg&q=85&w=1400&auto=format&fit=crop',
    alt: 'Orange Staten Island Ferry crossing New York Harbor toward Lower Manhattan — taxi and car service available at St. George Terminal with Island Ride',
    caption: 'St. George Ferry Terminal → Manhattan',
  },
  {
    src: 'https://images.unsplash.com/photo-1564248305-18f613798ef0?fm=jpg&q=85&w=1400&auto=format&fit=crop',
    alt: 'Statue of Liberty viewed from New York Harbor near Staten Island — Island Ride serves airport trips to Newark, JFK, and LaGuardia from Staten Island',
    caption: 'Statue of Liberty · New York Harbor',
  },
  {
    src: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?fm=jpg&q=85&w=1400&auto=format&fit=crop',
    alt: 'New York City skyline at dusk seen from Staten Island across the harbor — local cab service for daily rides, ferry connections, and airport transfers',
    caption: 'NYC skyline from Staten Island',
  },
];

export const NAV_LINKS = [
  { to: '/local-rides-staten-island', label: 'Local Rides' },
  { to: '/airport-rides-staten-island', label: 'Airport' },
  { to: '/staten-island-service-area', label: 'Service Area' },
  { to: '/contact', label: 'Contact' },
];
